import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Connectez directement votre compte Shine à ces applications et logiciels et gagnez du temps en automatisant votre gestion administrative et comptable.',
    fetchMore: 'Voir plus',
    title: 'Intégrations',
  },
  fr: {
    description:
      'Connectez directement votre compte Shine à ces applications et logiciels et gagnez du temps en automatisant votre gestion administrative et comptable.',
    fetchMore: 'Voir plus',
    title: 'Intégrations',
  },
});

export default locales;
